import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  alterarSenha: (atual, nova) => {
    return Vue.http.post('/api/alterarsenha', { atual, nova }).then(response => response.data);
  },
  alterarSenhaFornecedorWeb: (atual, nova) => {
    return Vue.http.post('/api/alterarsenha/fornecedor', { atual, nova }).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/alterar-senha/servico.js